import React, { ReactNode, useRef } from 'react'
import classNames from 'classnames'
import useFixedNavObserve from 'Components/hooks/use-fixed-nav-observe'

interface IProps {
  height: number
  renderContent(isFixed: boolean): ReactNode
  markOffset?: number
}

const StickyNav: React.FC<IProps> = ({
  height,
  renderContent,
  markOffset = 30,
}) => {
  const markRef = useRef<HTMLDivElement | null>(null)

  const isFixed = useFixedNavObserve({
    getMarkNode: () => markRef.current,
  })

  return (
    <React.Fragment>
      <div className="tw-relative" style={{ height }}>
        <div className="mark" ref={markRef} />
        <div
          className={classNames({
            'tw-fixed tw-w-full tw-top-0 tw-inset-x-0 tw-m-auto tw-transform tw-translate-x-0':
              isFixed,
          })}
          style={{ maxWidth: 1920, zIndex: 10000 }}
        >
          <div
            className={classNames({
              'tabs--fixed tw-left-312 lg:tw-left-340 tw-right-232 lg:tw-right-278':
                isFixed,
            })}
          >
            {renderContent(isFixed)}
          </div>
        </div>
      </div>
      <style jsx>
        {`
          .mark {
            position: absolute;
            top: -${markOffset}px;
            left: 0;
            right: 0;
            height: 1px;
          }

          .tabs--fixed {
            position: absolute;
            animation: fn 0.2s ease;
          }

          @keyframes fn {
            from {
              opacity: 0;
            }
            to {
              opacity: 1;
            }
          }
        `}
      </style>
    </React.Fragment>
  )
}

export default StickyNav
